import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";
import Country from "@/models/Country/Country";

export default class ContactBlock extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/contact-block';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetContactBlocks';

    static model_name = 'ContactBlock';

    static fields() {
		return {
			id: this.number(null).nullable(),
			display_type: this.attr(null),
			title_1: this.attr(null),
			title_2: this.attr(null),
			info: this.attr(null),
			country_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            country: this.belongsTo(Country, 'country_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Country() {
        return this.getRelated('country');
    }

}
